<template>
	<div>
		<transition-group name="toast" @after-leave="afterLeave">
			<div v-if="toastVisible" key="toast" class="toast">{{ toast }}</div>
			<div v-if="defModel.Visible" key="model" class="model">
				<div class="title">{{ defModel.title }}</div>
				<div class="content" v-if="defModel.content">{{ defModel.content }}</div>
				<div class="buttonBox">
					<div class="cancel" @click="defModel.success(0)" v-if="defModel.showCancel">
						<span :style="`color:${defModel.cancelColor}`">{{ defModel.cancelText }}</span>
					</div>
					<div class="confirm" @click="defModel.success(1)">
						<span :style="`color:${defModel.confirmColor}`">{{ defModel.confirmText }}</span>
					</div>
				</div>
			</div>
		</transition-group>
	</div>
	
</template>

<script setup>
	import { ref,watch,onMounted,render } from "vue";
	let props = defineProps({
		type:{type:String,default:''},
		content:{type:String,default:''},
		delay:{type:Number,default:3000},
		model:{type:Object,default:()=>{}},
		app:{Object,default:null}
	})
	let toast = ref('');
	let showToastTimeout = null;
	let toastVisible = ref(false);
	let defModel = ref({
			title: '提示',
			content: '',
			cancelText: '取消',
			showCancel:true,
			cancelColor:'#000',
			confirmText: '确定',
			confirmColor:'#007aff',
			success: null,
			Visible: false,
		});
	const showToast = (str, delay) => {
		return new Promise(resolve => {
			toast.value = str;
			toastVisible.value = true;
			clearTimeout(showToastTimeout);
			showToastTimeout = setTimeout(() => {
				heidToast();
				resolve();
			}, delay);
		});
	};
	const heidToast = () => {
		toastVisible.value = false;
	};
	let afterLeave=(e)=>{
		toast.value = '';
		// destroyPop.value&&destroyPop.value();
	}
	const showModel = opt => {
		let { title, content, cancelText, showCancel, confirmText, success } = opt;
		let _model={};
		_model.title = title ? title : '提示';
		_model.content = content ? content : '';
		cancelText ? (_model.cancelText = cancelText) : '';
		showCancel !=undefined ? (_model.showCancel = showCancel) : '';
		confirmText ? (_model.confirmText = confirmText) : '';
		_model.success = success ? success : () => {};
		_model.Visible = true;
		Object.assign(defModel.value,_model);
		defModel.value.success = e => {
			success(e);
			defModel.value.Visible = false;
			destroyPop.value&&destroyPop.value();
		};
	};
	if(props.type == 'toast'){
		showToast(props.content,props.delay);
	}else if(props.type == 'model'){
		showModel(props.model);
	}
	onMounted(()=>{
		
	})
	var destroyPop = ref();
	defineExpose({
		destroyPop,
		showToastTimeout,
	})
</script>

<style lang="scss" scoped>
	.toast {
		background: rgba(0, 0, 0, 0.8);
		padding: 10px 15px;
		font-size: 14px;
		color: white;
		border-radius: 4px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 99999;
	}
	
	.model {
		background-color: rgba(255, 255, 255, 1);
		box-shadow: 0 0 15px rgb(193, 193, 193);
		width: 300px;
		font-size: 14px;
		border-radius: 4px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 99999;
	}
	.model .title {
		width: 100%;
		height: 35px;
		padding: 5px 15px;
		box-sizing: border-box;
		background-color: rgb(239, 239, 239);
		text-align: left;
		font-size: 16px;
	}
	.model .content {
		padding: 15px;
		min-height: 35px;
		text-align: left;
	}
	.model .buttonBox {
		width: 100%;
		height: 45px;
		box-sizing: border-box;
		display: flex;
		padding: 5px;
		border-top: 1px solid rgb(226, 226, 226);
	}
	.buttonBox .cancel + div {
		border-left: 1px solid rgb(226, 226, 226);
	}
	.model .cancel,
	.model .confirm {
		flex: 1;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.model .buttonBox span {
		cursor: pointer;
		padding: 15px;
	}
	
	.toast-enter-active,
	.toast-leave-active {
		transition: opacity 0.5s ease;
	}
	.toast-enter-from,
	.toast-leave-to {
		opacity: 0;
	}
</style>